<template>
  <section id="sso" class="sso">
    <div class="container">
      <router-view />
    </div>
  </section>
  <SSOModal />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

import SSOModal from '@template/sso/_component/modal/index.vue';

export default {
  name: 'sso',
  components: {
    SSOModal
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';

.sso {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  background: @color_white;
  
  .container {
    overflow: auto;
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>